/** show value in bold font weight */
export const boldFormatter = (_row, _cell, value) => {
    return value ? `<b>${value}</b>` : '';
};
//# sourceMappingURL=boldFormatter.js.map